var map = {
	"./Z3RO.png": "26ee",
	"./Z3RO_2.png": "07bf",
	"./Z3RO_2.svg": "8c2c",
	"./academy.png": "b73e",
	"./aside-image.webp": "4082",
	"./chatbot.svg": "8781",
	"./dashboard-dark.webp": "40a4",
	"./dashboard-dark2.webp": "6677",
	"./dashboard.webp": "92b9",
	"./icon-download.svg": "dcef",
	"./icon-expand.svg": "5a11",
	"./icon-preview.svg": "f7c1",
	"./icon-print.svg": "6025",
	"./icon-shrink.svg": "7fa1",
	"./icon-zoom-in.svg": "b700",
	"./icon-zoom-out.svg": "7b61",
	"./imenu/EmitidaIcon.svg": "6ea5",
	"./imenu/EmitirIcon.svg": "14f5",
	"./imenu/FacturaIcon.svg": "b023",
	"./imenu/PresupuestoIcon.svg": "0f9c",
	"./imenu/ProformaIcon.svg": "fbd1",
	"./imenu/RecibidaIcon.svg": "78cc",
	"./imenu/SimplificadaIcon.svg": "ee0d",
	"./imenu/SubirDocumentoIcon.svg": "6dab",
	"./imenu/SubirVerifactuIcon.svg": "8a3d",
	"./invoize/logo-invoize-dark.svg": "8d49",
	"./invoize/logo-invoize.svg": "f13e",
	"./logo-edasinvoize-dark.webp": "86e0",
	"./logo-edasinvoize.webp": "6096",
	"./logo-invoize-dark.svg": "a257",
	"./logo-invoize-no-edas-dark.png": "6cb2",
	"./logo-invoize-no-edas.png": "fedd",
	"./logo-invoize.svg": "f51b",
	"./logo-smb-login.svg": "a46f",
	"./logo-zc-dark.webp": "2156",
	"./logo-zc-edasinvoize-dark.webp": "a70e",
	"./logo-zc-edasinvoize.webp": "64a6",
	"./logo-zc.webp": "96a3",
	"./oracle.png": "ec2a",
	"./partner-logo.svg": "1b3f",
	"./qrcodes/AppStoreQR.svg": "c205",
	"./qrcodes/AppStoreQR2.svg": "c057",
	"./qrcodes/PlayStoreQR.svg": "95a3",
	"./qrcodes/PlayStoreQR2.svg": "7a5a",
	"./trash.svg": "5665",
	"./zerocoma.png": "055d"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "bb6e";